import type { ProfileType } from 'src/types/profile'

export type WaterConsumptionType = {
  readonly id: number,
  readonly user: ProfileType['user_id'],
  datetime: Date | string,
  ml: number,
  caps: number,
}

export type WaterBody = {
  datetime: string,
  ml: number,
}

export function castWaterConsumption (water: WaterConsumptionType): WaterConsumptionType {
  return { ...water, datetime: new Date(water.datetime) }
}
